import { useContext, useEffect, useState } from "react";
import { CAPITAL_LOGO } from "../assets";
import { StatusChip } from "../utils/chipUtils";
import { authService, campaignService, regexService } from "../service";
import { loaderContext, notificationContext } from "../context/context";
import dateFormat, { getExpiryDate } from "../utils/dateFormat";
import numberFormat from "../utils/numberFormat";
import dayjs from "dayjs";

function InvoicePayment() {
  const toast = useContext(notificationContext);
  const { showLoader, hideLoader } = useContext(loaderContext);

  const [invoiceData, setInvoiceData] = useState({});
  const [searchData, setSearchData] = useState();
  const [amount, setAmount] = useState("");
  const [isError, setError] = useState([]);

  const getInvoiceDetails = async () => {
    showLoader();
    const response = await campaignService.getInvoiceDetails();
    hideLoader();

    if (response?.error) {
      toast.error(response.error.message);
      return;
    }

    if (response.data) {
      setInvoiceData(response?.data || []);
      setAmount(response?.data?.amount || "");
    }
  };

  const createOrder = async () => {
    showLoader();
    try {
      const response = await campaignService.createOrder(amount, invoiceData);
      if (response.data) {
        window.location.replace(response.data.responsepageURL);
      }
      if (response.error) {
        toast.error(response?.error?.message);
      }
    } catch (error) {
      toast.error();
    } finally {
      hideLoader();
    }
  };

  const validateForm = () => {
    setError([]);
    if (!amount || amount == 0) {
      setError((e) => [...e, "err_empty_value"]);
    }
    if (amount > invoiceData?.amount) {
      setError((e) => [...e, "err_invalid_amount"]);
    }
  };

  useEffect(() => {
    validateForm();
  }, [amount]);

  useEffect(() => {
    getInvoiceDetails();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="nav capital-head">
        <div className="nav-head">
          <img src={CAPITAL_LOGO} alt="logo" className="abc-logo" />
        </div>
      </div>
      <div className="container-md py-4">
        <div className="mb-3">
          {invoiceData?.status === "SUCCESS" && (
            <div className="cover toast-success p-1">
              Your Payment of Rs. {invoiceData?.editedamount} has been paid
              Successfully.{" "}
            </div>
          )}
          {invoiceData?.status === "FAILED" && (
            <div className="cover toast-error p-1">
              Your Payment of Rs. {invoiceData?.editedamount} has been paid
              failed.{" "}
            </div>
          )}
          {invoiceData?.status === "EXPIRED" && (
            <div className="cover toast-warning p-1">
              Your Invoice has been expired{" "}
            </div>
          )}
        </div>
        <div className="flex-center justify-content-between">
          <div>
            <h6>Invoice</h6>
            <p className="text-secondary">
              Invoice ID: {invoiceData?.invoice_no}
            </p>
          </div>
          {/* <div className=" flex-end flex-col justify-content-right">
            <div className="chip chip--success">03:20</div>
          </div> */}
        </div>
        <div className="mt-3 flex-wrap justify-content-between">
          <div className="fc-5 ">
            <div className="input-wrapper">
              <p className="title">Customer Name</p>
              <div className="p-1 bg-200">{invoiceData?.customer_name}</div>
            </div>
          </div>
          <div className="fc-5">
            <div className="input-wrapper">
              <p className="title">Customer ID</p>
              <div className="p-1 bg-200">{invoiceData?.customer_id}</div>
            </div>
          </div>
          <div className="fc-5">
            <div>
              <p className="title">Pay Amount</p>
              <div className="p-1 bg-200">
                {invoiceData?.amount && numberFormat(invoiceData?.amount)}
              </div>
            </div>
          </div>
          {
            invoiceData?.smsparam2&&
          <div className="fc-5 ">
            <div>
              <p className="title">LAN Number</p>
              <div className="p-1 bg-200">
                {invoiceData?.smsparam2}
              </div>
            </div>
          </div>
          }
          <div className="fc-5">
            <div>
              <p className="title">Expire at</p>
              <div className="p-1 bg-200">
                {invoiceData?.expiry_period &&
                  getExpiryDate(
                    invoiceData?.createdt,
                    invoiceData?.expiry_period
                  )}
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="flex-nowrap mb-2 ">
          <p className="fc-6">Merchant name</p>
          <p className="fc-6 text-right f-600"> {invoiceData?.IN_merc_name}</p>
        </div>
        <div className="flex-nowrap">
          <p className="fc-6">Pay Amount</p>
          <div className="fc-6 text-right f-600">
            <div className="input-wrapper">
              <lable
                className={
                  ((isError?.includes("err_invalid_amount") ||
                    isError?.includes("err_empty_value")) &&
                    "input border-error") ||
                  "input"
                }
              >
                <input
                  type="text"
                  placeholder="Enter your amount"
                  value={amount}
                  disabled={
                    invoiceData?.status !== "SUCCESS" &&
                    invoiceData?.status !== "EXPIRED"
                      ? false
                      : true
                  }
                  onChange={(e) =>
                    invoiceData?.status !== "SUCCESS" &&
                    invoiceData?.status !== "EXPIRED" &&
                    regexService.isAmount(e.target.value) &&
                    setAmount(e.target.value)
                  }
                />
              </lable>
              {(isError?.includes("err_invalid_amount") && (
                <p className="text-danger help-text mt-1">
                  Amount Exceed pay amount
                </p>
              )) ||
                (isError?.includes("err_empty_value") && (
                  <p className="text-danger help-text mt-1">
                    Amount can't be empty
                  </p>
                ))}
            </div>
          </div>
        </div>
        <hr />
        <div className="text-right">
          {(isError?.length > 0 && (
            <button className="btn-disabled btn--sm">Continue</button>
          )) ||
            ((!invoiceData ||
              (invoiceData?.status !== "SUCCESS" &&
                invoiceData?.status !== "EXPIRED")) && (
              <button className="btn-primary btn--sm" onClick={createOrder}>
                Continue
              </button>
            ))}
        </div>
      </div>
    </div>
  );
}

export default InvoicePayment;
